import { render, staticRenderFns } from "./report-history-xls.vue?vue&type=template&id=3db9d8f7"
import script from "./report-history-xls.vue?vue&type=script&lang=js"
export * from "./report-history-xls.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports